var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "contactus_page",
      style: {
        width: _vm.showNavBar ? "100vw" : "100%",
        padding: _vm.showNavBar ? "calc(20 * 100vw / 1920)" : 0,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "contactus",
          style: {
            margin: _vm.showNavBar ? "calc(20 * 100vw / 1920) auto" : 0,
          },
        },
        [
          _vm.showNavBar
            ? _c("p", { staticClass: "directory" }, [
                _c(
                  "span",
                  {
                    staticClass: "directory_home",
                    on: { click: _vm.homeClick },
                  },
                  [_vm._v("Home ")]
                ),
                _vm._v(" > Contact\n      Us\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "contactus_title" }, [_vm._v("Contact Us")]),
          _vm._v(" "),
          _c("div", { staticClass: "contactus_main" }, [
            _c(
              "div",
              { staticClass: "list" },
              _vm._l(_vm.customerServiceHotlink, function (item, index) {
                return _c("div", { key: index, staticClass: "list_li" }, [
                  _c("img", {
                    attrs: { alt: "图片", src: _vm.$baseUrl + item.image },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "email" }, [
                    _vm._v(_vm._s(item.email)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "email" }, [
                    _vm._v(_vm._s(item.domain)),
                  ]),
                  _vm._v(" "),
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("div", { staticClass: "tel" }, [
                    _vm._v(_vm._s(item.contact)),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "contact_info_img" }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "teltext flex-row" }, [
      _c("div", { staticClass: "iconfont icon-tel" }),
      _vm._v("\n            /\n            "),
      _c("div", { staticClass: "iconfont icon-wechat" }),
      _vm._v("\n            /\n            "),
      _c("div", { staticClass: "iconfont icon-whatsapp" }),
      _vm._v("\n            :\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }